import { render, staticRenderFns } from "./block-menu.vue?vue&type=template&id=97e28738&scoped=true&"
import script from "./block-menu.vue?vue&type=script&lang=js&"
export * from "./block-menu.vue?vue&type=script&lang=js&"
import style0 from "./block-menu.vue?vue&type=style&index=0&id=97e28738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e28738",
  null
  
)

export default component.exports